import React, { useCallback, useContext, useRef } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../../Popovers/redux/hooks';
import { PopoverType } from '../../../../Popovers/redux/types';
import AddToGroupPopover from '../../../_partials/AddToGroupPopup';
import AddToGroupButton from '../AddToGroupButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
const offsetModifier = [
    0,
    20
];
const AddToGroupButtonWithPopover = ({ deviation, actionBarType })=>{
    const isMobile = useContext(MobileContext);
    const toggleRef = useRef(null);
    const { popover, pushPopover, removePopover } = usePopover(actionBarType === 'primary' ? PopoverType.ADD_TO_GROUP_PRIMARY : PopoverType.ADD_TO_GROUP_SECONDARY);
    const togglePopover = ()=>{
        if (popover.isOpen) {
            removePopover();
        } else {
            pushPopover();
        }
    };
    const handleOnClickOutside = useCallback((e)=>{
        if (toggleRef.current && toggleRef.current.contains(e.target) || isMobile) {
            return;
        }
        removePopover();
    }, [
        removePopover,
        isMobile
    ]);
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        ref: toggleRef,
        popoverContent: /*#__PURE__*/ React.createElement(AddToGroupPopover, {
            actionbarType: actionBarType,
            deviation: deviation,
            onClose: removePopover
        }),
        isVisible: popover.isOpen,
        placement: "bottom",
        offsetModifier: offsetModifier,
        onClickOutside: handleOnClickOutside
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        activated: popover.isOpen,
        deviation: deviation,
        onClick: togglePopover,
        withTooltip: !popover.isOpen
    }));
};
AddToGroupButtonWithPopover.displayName = 'AddToGroupButtonWithPopover';
export default AddToGroupButtonWithPopover;

//# sourceMappingURL=AddToGroupButtonWithPopover.js.map